import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authenticationSlice from './authentication/auth';
import applicationSlice from './application/applicationSlice';
import permissionsSlice from './permissions/permissionsSlice';
import patientsSlice from './patients/patientsSlice';
import roomPropertiesSlice from './roomProperties/roomPropertiesSlice';
import interventionRoomPropertiesSlice from './interventionRoomProperties/interventionRoomPropertiesSlice';
import errorDialogSlice from './errorDialog/errorDialogSlice';
import toastSlice from './toast/toastSlice';
import treatmentPlanTemplatesSlice from './treatmentPlanTemplates/treatmentPlanTemplatesSlice';
import interventionTemplatesSlice from './interventionTemplates/interventionTemplatesSlice';
import staffCompetencesSlice from './staffCompetences/staffCompetencesSlice';
import staffSlice from './staff/staffSlice';
import locationsSlice from './locations/locationsSlice';

export const store = configureStore({
  reducer: combineReducers({
    authenticationSlice,
    applicationSlice,
    permissionsSlice,
    patientsSlice,
    roomPropertiesSlice,
    interventionRoomPropertiesSlice,
    errorDialogSlice,
    toastSlice,
    treatmentPlanTemplatesSlice,
    interventionTemplatesSlice,
    staffCompetencesSlice,
    staffSlice,
    locationsSlice,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false // to avoid error while storing authenticationSlice.kcObject(which is non-serializable object).
    })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
